export default "__VITE_ASSET__B5s82OmF__"